<!-- Content -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div medsurf-design-content-input-group>
      <!-- Label -->
      <medsurf-design-form-control-input-text [formField]="false"
        [class]="'w-full'"
        [placeholder]="'global.answer'"
        [control]="form.controls.label"
        (valueChange)="onSubmit()">
      </medsurf-design-form-control-input-text>
      <!-- Delete -->
      <button medsurf-design-input-button [id]="'mapping_choice_remove'"
        [title]="'global.choice_remove' | translate"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_FUllHEIGHT"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
      (click)="removeChoice()"></button>
    </div>
  </medsurf-design-form-control-form>
}
